import { SET_DASHBOARD_NEEDS_REFRESH } from "../actions/dashboardActions";

const initialState = {
  dashboardNeedsRefresh: false,
};

const dashboardReducer = (state = initialState, action) => {
  if (action.type === SET_DASHBOARD_NEEDS_REFRESH) {
    return {
      ...state,
      dashboardNeedsRefresh: action.payload,
    };
  }
  return state;
};

export default dashboardReducer;
